import { LitElement, html, css } from 'lit';
import { customElement, property, state, query } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/themes/light.css';
import '@shoelace-style/shoelace/dist/shoelace.js';

// const host = 'http://localhost:2131'
const host = ''

@customElement('vxc-login')
export class TLoginForm extends LitElement {

	// properties
	@property({ type: String, attribute: 'text-welcome'}) 	textWelcome: string  = "Welcome Back !"
	@property({ type: String, attribute: 'text-username'}) 	textUsername: string = "username"
	@property({ type: String, attribute: 'text-password'}) 	textPassword: string = "password"
	@property({ type: String, attribute: 'text-submit'}) 	textSubmit: string   = "Login"
	@property({ type: String, attribute: 'text-lostpwd'}) 	textLostPwd: string  = "" //"Forgot Password ?"
	@property({ type: String, attribute: 'text-register'}) 	textRegister: string = "" //"Sign Up"
	@property({ type: String, attribute: 'text-error'}) 	textError: string    = "Invalid credentials. Please try again."

	// states
  	@state() private error: string = '';

	// queries
	@query('#username') private usernameInput!: HTMLInputElement;
	@query('#password') private passwordInput!: HTMLInputElement;

  static styles = css`
    :host {
		display: block;
		max-width: 400px;
		margin: 0 auto;
		padding: 20px;
    }
    form {
		display: flex;
		flex-direction: column;
		gap: 15px;
    }
    .links {
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
    }
    .links a {
		text-decoration: none;
		color: #0d6efd;
    }
    .links a:hover {
      	text-decoration: underline;
    }
	#title {
		font-weight: bold;
		text-align: center;
		font-size: 2rem;
		padding: 1rem;
	}
    #err-msg {
  		display: flex;
  		gap: 0.5rem;
		font-size: 0.8rem;
		color: #b51a00;
	}`;

  	private async handleSubmit(e: Event) {
    	e.preventDefault()
    	const form = e.target as HTMLFormElement
    	const formData = { username: this.usernameInput.value, password: this.passwordInput.value }

		try {
			const response = await fetch(`${host}/token?`+(new URLSearchParams(formData)).toString())
			if (response.ok) {
				const { token } = await response.json()
				sessionStorage.setItem('token', token)
				window.location.href = '/dashboard'
			} 
			else {
				this.error = 'Invalid credentials. Please try again.'
			}
		} 
		catch(e) { this.error = 'An error occurred. Please try again.' }
		finally  { form.reset() }
  }

  render() {
    return html`
		<div id="title">${this.textWelcome}</div>
      	<form @submit=${this.handleSubmit}>
        	<sl-input 
				id="username"
				name="username" 
				placeholder="${this.textUsername}" 
				required>
				<span slot="prefix"><svg fill="#000000" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.0778418,12.9406987 L18.5345074,14.5119103 C19.4269931,14.9175857 20,15.8074678 20,16.7878265 L20,17.5 C20,18.8807119 18.8807119,20 17.5,20 L6.5,20 C5.11928813,20 4,18.8807119 4,17.5 L4,16.7878265 C4,15.8074678 4.57300693,14.9175857 5.46549264,14.5119103 L8.92215823,12.9406987 C7.75209123,12.0255364 7,10.6005984 7,9 C7,6.23857625 9.23857625,4 12,4 C14.7614237,4 17,6.23857625 17,9 C17,10.6005984 16.2479088,12.0255364 15.0778418,12.9406987 L15.0778418,12.9406987 Z M9.96126583,13.5668358 L5.87929558,15.4222768 C5.34380416,15.665682 5,16.1996113 5,16.7878265 L5,17.5 C5,18.3284271 5.67157288,19 6.5,19 L17.5,19 C18.3284271,19 19,18.3284271 19,17.5 L19,16.7878265 C19,16.1996113 18.6561958,15.665682 18.1207044,15.4222768 L14.0387342,13.5668358 C13.4161054,13.8452135 12.7261289,14 12,14 C11.2738711,14 10.5838946,13.8452135 9.96126583,13.5668358 L9.96126583,13.5668358 Z M12,13 C14.209139,13 16,11.209139 16,9 C16,6.790861 14.209139,5 12,5 C9.790861,5 8,6.790861 8,9 C8,11.209139 9.790861,13 12,13 Z"></path> </g></svg></span>
			</sl-input>

			<sl-input 
				id="password"
				name="password" 
				placeholder="${this.textPassword}" 
				type="password" 
				password-toggle
				required>
				<span slot="prefix"><svg fill="#000000" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.9499909,19 C16.7183558,20.1411202 15.709479,21 14.5,21 L5.5,21 C4.11928813,21 3,19.8807119 3,18.5 L3,11.5 C3,10.290521 3.85887984,9.28164422 5,9.05000906 L5,8 C5,5.23857625 7.23857625,3 10,3 C12.7614237,3 15,5.23857625 15,8 L15,9.05000906 C16.1411202,9.28164422 17,10.290521 17,11.5 L17,13 L18.5,13 C19.8807119,13 21,14.1192881 21,15.5 L21,16.5 C21,17.8807119 19.8807119,19 18.5,19 L16.9499909,19 L16.9499909,19 Z M15.9146471,19 L11.5,19 C10.1192881,19 9,17.8807119 9,16.5 L9,15.5 C9,14.1192881 10.1192881,13 11.5,13 L16,13 L16,11.5 C16,10.710487 15.3900375,10.0634383 14.6156506,10.0043921 C14.5785296,10.0131823 14.5398081,10.0178344 14.5,10.0178344 C14.4540106,10.0178344 14.4094714,10.0116254 14.367175,10 L5.5,10 C4.67157288,10 4,10.6715729 4,11.5 L4,18.5 C4,19.3284271 4.67157288,20 5.5,20 L14.5,20 C15.1531094,20 15.7087289,19.5825962 15.9146471,19 L15.9146471,19 Z M6,9 L14,9 L14,8 C14,5.790861 12.209139,4 10,4 C7.790861,4 6,5.790861 6,8 L6,9 Z M20,16.5 L20,15.5 C20,14.6715729 19.3284271,14 18.5,14 L11.5,14 C10.6715729,14 10,14.6715729 10,15.5 L10,16.5 C10,17.3284271 10.6715729,18 11.5,18 L18.5,18 C19.3284271,18 20,17.3284271 20,16.5 Z M11.5,15 L12.5,15 C12.7761424,15 13,15.2238576 13,15.5 L13,16.5 C13,16.7761424 12.7761424,17 12.5,17 L11.5,17 C11.2238576,17 11,16.7761424 11,16.5 L11,15.5 C11,15.2238576 11.2238576,15 11.5,15 Z M14.5,15 L15.5,15 C15.7761424,15 16,15.2238576 16,15.5 L16,16.5 C16,16.7761424 15.7761424,17 15.5,17 L14.5,17 C14.2238576,17 14,16.7761424 14,16.5 L14,15.5 C14,15.2238576 14.2238576,15 14.5,15 Z M17.5,15 L18.5,15 C18.7761424,15 19,15.2238576 19,15.5 L19,16.5 C19,16.7761424 18.7761424,17 18.5,17 L17.5,17 C17.2238576,17 17,16.7761424 17,16.5 L17,15.5 C17,15.2238576 17.2238576,15 17.5,15 Z"></path> </g></span>
			</sl-input>
			
      		${this.error ? html`
				<div id="err-msg">
					<span><svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="white"></rect> <path fill-rule="evenodd" clip-rule="evenodd" d="M11 13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V13ZM13 15.9888C13 15.4365 12.5523 14.9888 12 14.9888C11.4477 14.9888 11 15.4365 11 15.9888V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V15.9888ZM9.37735 4.66136C10.5204 2.60393 13.4793 2.60393 14.6223 4.66136L21.2233 16.5431C22.3341 18.5427 20.8882 21 18.6008 21H5.39885C3.11139 21 1.66549 18.5427 2.77637 16.5431L9.37735 4.66136Z" fill="#b51a00"></path> </g></svg></span>
					<span>${this.error}</span>
				</div>
      		` : ''}
			<sl-button type="submit" variant="success">Login</sl-button>

			<div class="links">
				<a href="/lost-password">${this.textLostPwd}</a>
				<a href="/signup">${this.textRegister}</a>
			</div>
		</form>
    `;
  }
}

// Type declarations
declare global {
  interface HTMLElementTagNameMap {
      'vxc-login': TLoginForm;
  }
}